import styled, { css } from 'styled-components';

interface GridWrapperStyleProps {
  fontSize: string | number;
  headerFontSize?: number;
}

export const GridWrapperStyled = styled.div.attrs({
  className: 'ag-theme-alpine',
})<GridWrapperStyleProps>`
  height: 100%;
  width: 100%;
  z-index: 0;

  ${({ theme, fontSize, headerFontSize }) => css`
    .ag-header-cell-text {
      white-space: pre-line;
      font-size: ${headerFontSize ? theme.fontSizes[headerFontSize] : theme.fontSizes[300]};
      font-weight: ${theme.fontWeights[600]};
      color: ${theme.colors.neutral[1000]};
    }

    .ag-root-wrapper {
      border: 1px solid ${theme.colors.primary[100]};
    }

    .ag-cell-focus {
      //Disable border for cell focus, we want the border to be shown for the whole row
      border: none !important;
    }

    .ag-row-focus {
      border: 1px solid ${theme.colors.primary[700]};
      background: ${theme.colors.primary[200]};
    }
    .ag-row-hover {
      background: ${theme.colors.primary[100]};
    }

    .ag-row-selected {
      background-color: ${theme.colors.primary[100]};
    }
    .ag-row-hover {
      background-color: ${theme.colors.primary[100]} !important;
    }
    .ag-cell {
      border-right-color: ${theme.colors.grey[200]};
      border-right-width: 1px;
      border-right-style: solid;
    }

    .ag-row {
      background-color: ${theme.colors.white};
    }
    .ag-drag-handle {
      z-index: 1;
    }
    .ag-floating-filter-input .ag-input-field .ag-text-field-input-wrapper .ag-input-field-input {
      height: ${theme.spacings[550]};
      min-height: ${theme.spacings[550]};
    }
    .ag-body-viewport .ag-pinned-left-cols-container .ag-row {
      background-color: ${theme.colors.neutral[100]};
    }
    .ag-body-viewport .ag-pinned-right-cols-container .ag-row {
      background-color: ${theme.colors.neutral[100]};
    }
    .ag-checkbox-cell {
      justify-content: center;
    }
  `};
`;
